import axios from 'axios';
import { BASE_URL } from '../utils/config';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = {
      authtoken: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.idToken,
      nonce: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.nonce,
      version: import.meta.env.VITE_VERSION || null,
      fwdorigin: 'INTERNAL_MANAGER',
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (res) => {
    // if res is 401 delete token
    return res;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default axiosInstance;
